import { clientOnly } from '@solidjs/start';
import { Meta, Title } from '@solidjs/meta';
import { getConfigValue } from '../../../../../modules/config';
import type { RouteDefinition, RouteSectionProps } from '@solidjs/router';

const StripeProvider = clientOnly(async () => ({
	default: (await import('@troon/payments/stripe')).StripeProvider,
}));

export default function Checkout(props: RouteSectionProps) {
	return (
		<>
			<Meta name="robots" content="noindex" />
			<Title>Checkout | Golf with Access</Title>
			<StripeProvider publishableKey={getConfigValue('STRIPE_PUBLISHABLE_KEY')}>{props.children}</StripeProvider>
		</>
	);
}

export const route = { info: { nav: { appearance: 'minimal' } } } satisfies RouteDefinition;
